import { Reveal } from "@/components/campaign/Reveal";

const INCLUDES = [
  ["60 minutes with Dr. Crosson, DO", "A full hour, not a rushed slot \u2014 your whole story gets heard."],
  ["Health history and timeline review", "What changed, when it started, and what you\u2019ve already tried."],
  ["Review of labs you already have", "Bring prior results \u2014 even the ones you were told look normal."],
  ["Physical exam", "A hands-on evaluation as part of the whole-person picture."],
  ["InBody body-composition assessment", "A factual baseline for muscle, fat and hydration \u2014 beyond the scale."],
  ["A clear next-step plan", "Plain-language next steps, and a discussion of whether further testing makes sense."],
];

export const FmFirstVisit = ({ onRequest }) => (
  <section id="visit" data-testid="fm-first-visit-section" className="scroll-mt-20 py-16 sm:py-24 bg-white border-y border-[var(--brand-gold-soft)]">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <div className="grid lg:grid-cols-[1.4fr_1fr] gap-10 lg:gap-14 items-start">
        <div>
          <Reveal>
            <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-[var(--brand-gold)]">
              Your first visit
            </p>
            <h2 className="mt-3 font-serif-brand text-3xl sm:text-4xl font-medium text-[var(--brand-navy)] leading-tight">
              What your first visit includes
            </h2>
          </Reveal>
          <div className="mt-8 space-y-6">
            {INCLUDES.map(([title, body], i) => (
              <Reveal key={title} delay={i * 0.08}>
                <div data-testid={`fm-visit-item-${i + 1}`} className="relative pl-14">
                  <span
                    className="absolute left-0 top-0 h-10 w-10 flex items-center justify-center border-2 border-[var(--brand-gold)] font-serif-brand text-xl font-semibold text-[var(--brand-navy)]"
                    aria-hidden="true"
                  >
                    {i + 1}
                  </span>
                  <h3 className="font-serif-brand text-xl font-medium text-[var(--brand-navy)]">{title}</h3>
                  <p className="mt-1.5 text-base leading-relaxed">{body}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <button
              data-testid="fm-visit-request-button"
              onClick={onRequest}
              className="mt-9 inline-flex items-center justify-center bg-[var(--brand-navy)] text-white text-base font-semibold px-8 py-3.5 hover:bg-[var(--brand-navy-deep)] transition-colors"
            >
              Request an Appointment
            </button>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="relative lg:sticky lg:top-24">
            <div className="absolute -inset-2 border border-[var(--brand-gold)] opacity-50" aria-hidden="true" />
            <img
              src="/images/fm/assessment.webp"
              alt="A clinician guiding a patient through a body-composition assessment."
              className="relative w-full h-80 lg:h-[480px] object-cover object-top shadow-lg"
              loading="lazy"
            />
            <p className="mt-4 text-sm text-[var(--brand-muted)]">
              Every first visit includes an InBody body-composition assessment.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
